import React from "react"
import CustomCalendarMonth from "./CustomCalendarMonth"
import { CalendarDate } from "./types"
import classes from "./CustomCalendar.module.css"
import CustomCalendarHead from "./CustomCalendarHead"
import { addCalendarMonths } from "./utils"

interface Props {
  min?: CalendarDate
  max?: CalendarDate
  today: CalendarDate
  selected?: CalendarDate
  currentPageDate: CalendarDate
  onPageDateChange: (value: CalendarDate) => void
  selectable?: (date: CalendarDate) => boolean
  onSelect?: (date: CalendarDate) => void
  enableMonthControls?: boolean
}

const CustomCalendar = ({
  min,
  max,
  today,
  currentPageDate,
  onPageDateChange,
  selectable,
  onSelect,
  enableMonthControls,
  selected,
}: Props) => {
  const handleMonthPrev = () => {
    onPageDateChange(addCalendarMonths(currentPageDate, -1))
  }

  const handleMonthNext = () => {
    onPageDateChange(addCalendarMonths(currentPageDate, 1))
  }

  return (
    <div className={classes.root}>
      <CustomCalendarHead
        currentPageDate={currentPageDate}
        showControls={enableMonthControls}
        min={min}
        max={max}
        className="mb-10"
        onPrevMonthClick={handleMonthPrev}
        onNextMonthClick={handleMonthNext}
      />
      <CustomCalendarMonth
        today={today}
        currentPageDate={currentPageDate}
        selectable={selectable}
        onSelect={onSelect}
        selectedDate={selected}
      />
    </div>
  )
}

export default CustomCalendar
